let whatsappIcons = document.querySelectorAll('.whatsapp-icon');
let icons2 = document.querySelectorAll('.need-help .nh3');
whatsappIcons.forEach(function(icon) {
  icon.addEventListener('click', function() {
    var url = "https://api.whatsapp.com/send/?phone=918700986208&text=I%27m+interested+in+your+wallpaper+collection&type=phone_number&app_absent=0";
    window.open(url, '_blank');
  })
})
      icons2.forEach(function(icon) {
  icon.addEventListener('click', function() {
    window.location.href = "https://api.whatsapp.com/send/?phone=918700986208&text=I%27m+interested+in+your+wallpaper+collection&type=phone_number&app_absent=0";
  })
})





let phoneIcons = document.querySelectorAll('.phone-icon');
let icons3 = document.querySelectorAll('.need-help .nh4');
phoneIcons.forEach(function(icon) {
  icon.addEventListener('click', function() {
    window.location.href = "tel: 09310845706";
  })
})
      icons3.forEach(function(icon) {
  icon.addEventListener('click', function() {
    window.location.href = "tel: 09310845706";
  })
})


let mailIcons = document.querySelectorAll('.mail-icon');
mailIcons.forEach(function(icon) {
  icon.addEventListener('click', function() {
    window.location.href = "mailto:contact@lifencolors.in";
  })
})

let searchInput1 = document.querySelector(".search-box input");
let searchBox1 = document.querySelector(".search-box");
let searchContent1 = document.querySelector(".search-content");
let searchView1 = document.querySelector(".view-all-search");
searchContent1.classList.add("d-none");
searchView1.classList.add("d-none");
searchInput1.addEventListener("input", function(){
  if (searchInput1.value.length > 1) {
    searchContent1.classList.remove("d-none");
    searchView1.classList.remove("d-none");
    searchBox1.classList.add("search-border");
  } else {
    searchContent1.classList.add("d-none");
    searchView1.classList.add("d-none");
    searchBox1.classList.remove("search-border");
  }
});


// Get references to the search icon and input field
const searchIcon1 = document.querySelectorAll('.search-icon');
console.log("searchIcon1", searchIcon1);
const searchInput2 = document.querySelector('.search-box input');
console.log("searchInput2", searchInput2);

// Add a click event listener to each search icon
searchIcon1.forEach((icon) => {
  icon.addEventListener('click', () => {
    // Set focus on the search input field when the icon is clicked
    searchInput2.focus();
    searchInput2.select();
  });
});

// Get the quantity buttons
const quantityButtons2 = document.querySelectorAll('.quantity-input button');
// Add a click event listener to each button
quantityButtons2.forEach(btn => {
btn.addEventListener('click', event => {
  // Prevent the default behavior
  event.preventDefault();
  // Get the input field associated with the btn
  const InputField = document.querySelector('.quantity-input input.quantity');
  const InputField1 = document.querySelector('.sticky-quantity #sticky-quantity-value');
  let Cushions = document.querySelector('.cushions');
 
  // Get the current value of the input field
   let CurrentValue = InputField ? parseInt(InputField.value) : 0;
   let CurrentValue2 = InputField1 ? parseInt(InputField1.value) : 0;
    // console.log("CurrentValue2",CurrentValue2);
  // Increment or decrement the value based on the btn clicked
  if (btn.classList.contains('qn-plus')) {
    CurrentValue++;
    CurrentValue2++;
    console.log("CurrentValue",CurrentValue2,CurrentValue)
  } else if (btn.classList.contains('qn-minus')) {
    if (Cushions) {
    // Check if currentValue and currentValue2 are 4 or more
    const selectedVariant = document.querySelector("label.active").closest(".variants-option")
    if(selectedVariant.classList.contains("Sample") && CurrentValue == 1 && CurrentValue2 == 1){
      CurrentValue;
      CurrentValue2;
    }else if(selectedVariant.classList.contains("Sample") && CurrentValue > 1 && CurrentValue2 > 1){
      CurrentValue--;
      CurrentValue2--;
    }
    else if (CurrentValue >= 1 && CurrentValue2 >= 1) {
      CurrentValue = CurrentValue > 2 ? CurrentValue - 1 : 1;
      CurrentValue2 = CurrentValue2 > 2 ? CurrentValue2 - 1 : 1;
    }
  } else {
    // General case: decrement values but not below 1
    CurrentValue = CurrentValue > 1 ? CurrentValue - 1 : 1;
    CurrentValue2 = CurrentValue2 > 1 ? CurrentValue2 - 1 : 1;
  }
  }
  // Update the value of the input field
  InputField.value = CurrentValue;
  InputField1.value = CurrentValue2;
});
});


// Get the quantity buttons
const quantityButtons1 = document.querySelectorAll('.sticky-quantity button');

// Add a click event listener to each button
quantityButtons1.forEach(button => {
button.addEventListener('click', event => {
  // Prevent the default behavior
  event.preventDefault();
  // Get the input field associated with the button
  const inputField = button.parentNode.querySelector('.sticky-quantity #sticky-quantity-value');
  const inputField1 = document.querySelector('.quantity-input input.quantity');
  let cushions = document.querySelector('.cushions');
  // console.log("cushions",cushions);
  // Get the current value of the input field
  let currentValue = parseInt(inputField.value);
  let currentValue2 = parseInt(inputField1.value);
  // Increment or decrement the value based on the button clicked
  if (button.classList.contains('sticky-plus')) {
    currentValue++;
    currentValue2++;
  } else if (button.classList.contains('sticky-minus')) {
    if (cushions) {
    // Check if currentValue and currentValue2 are 4 or more
    const selectedVariant = document.querySelector("label.active").closest(".variants-option")
    if(selectedVariant.classList.contains("Sample") && currentValue == 1 && currentValue2 == 1){
      currentValue;
      currentValue2;
    }else if(selectedVariant.classList.contains("Sample") && currentValue > 1 && currentValue2 > 1){
      currentValue--;
      currentValue2--;
    }
    else if (currentValue >= 1 && currentValue2 >= 1) {
      currentValue = currentValue > 2 ? currentValue - 1 : 1;
      currentValue2 = currentValue2 > 2 ? currentValue2 - 1 : 1;
    }  
  } else {
    // General case: decrement values but not below 1
    currentValue = currentValue > 1 ? currentValue - 1 : 1;
    currentValue2 = currentValue2 > 1 ? currentValue2 - 1 : 1;
  }
  }
  // Update the value of the input field
  inputField.value = currentValue;
  inputField1.value = currentValue2;
});
});



const divElements = document.querySelectorAll('.youtube-player>div');
divElements.forEach((divElement) => {
  const imgElement = divElement.querySelector('img');
  if (imgElement) {
    imgElement.setAttribute('loading', 'lazy');
  }
});



$(document).ready(function() {
    // Add a click event handler to the first button
    $(".sticky-btn").click(function() {
        // Trigger a click event on the second button
        $(".ajax-cart.primary-button.main-atc").click();
    });
});



// Wait for the DOM content to load
document.addEventListener("DOMContentLoaded", function () {
  // Select all div elements with the class .lazy-background
  const lazyBackgroundDivs = document.querySelectorAll('.lazy-background');

  // Loop through each div and find child img elements
  lazyBackgroundDivs.forEach((div) => {
    const images = div.querySelectorAll('img');
    
    // Add the loading="lazy" attribute to each img element
    images.forEach((img) => {
      img.setAttribute('loading', 'lazy');
    });
  });
});